import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Container } from '@mui/material';
import EmersonHeader from './components/EmersonHeader';
import EmersonFooter from './components/EmersonFooter';
import Home from './components/Home';
import Disclaimer from './components/Disclaimer';
import './App.css';

const hotspots = require('./data/petrohotspots.json');

function App() {
 

  const titles = [];
  if (hotspots) {
    hotspots.map((h) => {
      return titles.push(h.data.title);
    });
  };


  return (
    <Router>
      <Container maxWidth="xxl" disableGutters={true} className="header">
        <EmersonHeader />
      </Container>

      <div className='fade-in'>
        <Routes>
          <Route exact path="/" element={ <Home /> } />
          <Route path="/disclaimer" element={ <Disclaimer /> } />

          { titles.map((t, index) => {
              return <Route key={index} path={`/#${t}`} element={ <Home /> } />
            })
          }
        </Routes>
      </div>

      <Container maxWidth="xxl" disableGutters={true} className="footer">
        <EmersonFooter />
      </Container>
    </Router>
  );
}

export default App;
